import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import {
    GetSurveyRequest,
    GetSurveyResponse,
    Guid,
    SubmitSurveyRequest,
    Survey,
    SurveyAnswerRequest
} from '@lsq-frontend/remote-services/enterprise/common';
import {
    GetSurveyService,
    SubmitSurveyService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import {
    //  LsqQuestionModalComponent,
    Modal,
    ModalWorkflowService
} from '@lsq-frontend/common-ui';
import { NotificationsService } from '../notifications/notifications.service';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';

@Injectable({ providedIn: 'root' })
export class SurveyService {
    constructor(
        private _alertService: AlertService,
        private _workflowService: ModalWorkflowService,
        private _getSurveyService: GetSurveyService,
        private _submitSurveyService: SubmitSurveyService,
        private _notificationsService: NotificationsService,
        private _userService: UserService
    ) {
        SingletonServiceGuard.register('SurveyService');
        this._submitSurveyService.dataStream.subscribe((response: any) => {
            this._alertService.success(
                'Survey Successfully Submitted, Thank you for your Feedback!'
            );
            this._notificationsService.refreshNotifications();
        });

        this._getSurveyService.dataStream.subscribe((response: GetSurveyResponse) => {
            this.showSurveyModal(response.survey);
        });
    }

    public startSurvey(surveyKey: Guid): void {
        this._getSurveyService.execute(
            new GetSurveyRequest({
                surveyKey: surveyKey
            })
        );
    }

    private showSurveyModal(survey: Survey): void {
        // Create a 'step' in the ModalWorkflow for each question.
        const surveyFormGroup = new FormGroup({});
        const modalList: Modal[] = [];
        survey.questions.forEach((question, index) => {
            surveyFormGroup.addControl(
                'question' + index + 'control',
                new FormControl({ value: '', disabled: false })
            );
            modalList.push(
                new Modal({
                    id: 'question' + index + 'modal',
                    title: survey.title,
                    // bodyComponent: LsqQuestionModalComponent,
                    width: '71.5rem',
                    showCloseButton: true,
                    showFooter: true,
                    showOkButton: true,
                    okButtonText: 'Next',
                    onOkClick: () => {
                        this._workflowService.nextStep();
                    },
                    showCancelButton: true,
                    cancelButtonText: 'Back',
                    onCancelClick: () => {
                        this._workflowService.previousStep();
                    },
                    data: {
                        isPreview: true,
                        formGroup: surveyFormGroup,
                        question: question,
                        questionControl: 'question' + index + 'control',
                        totalQuestionCount: survey.questions.length
                    }
                })
            );
        });

        // Configure the first and last question modals.
        modalList[0].cancelButtonText = 'Cancel';
        modalList[0].onCancelClick = () => {
            this._workflowService.hideWorkflow();
        };
        modalList[modalList.length - 1].okButtonText = 'Submit';
        modalList[modalList.length - 1].onOkClick = () => {
            this.submitSurvey(surveyFormGroup, survey);
            this._workflowService.hideWorkflow();
        };

        // Start the survey.
        this._workflowService.showWorkflow(modalList);
    }

    private submitSurvey(surveyFormGroup: FormGroup, survey: Survey): void {
        const answers = [];

        Object.keys(surveyFormGroup.controls).forEach((controlName, index) => {
            answers.push(
                new SurveyAnswerRequest({
                    surveyQuestionKey: survey.questions[index].surveyQuestionKey,
                    answer: surveyFormGroup.get(controlName).value.toString()
                })
            );
        });

        this._submitSurveyService.execute(
            new SubmitSurveyRequest({
                surveyKey: survey.surveyKey,
                companyKey: this._userService.getCompanyKey(),
                answers: answers
            })
        );
    }
}
